module.exports = __webpack_public_path__ + "img/bf.70956d10.svg";